import { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";

import { fetchLessons } from "../../api/lessons/students";

import "./index.css";

function EmployeeReaderItem(props) {
  const { path, text, active } = props;
  const navigate = useNavigate();

  function onClick() {
    navigate(path);
  }

  function getClassName() {
    if (active)
      return "EmployeeReaderSidebarItem EmployeeReaderSidebarItemActive"
    return "EmployeeReaderSidebarItem";
  }

  return (
    <div className="EmployeeReaderSidebarItemContainer">
      <div className={getClassName()} onClick={onClick}>
        <div className="EmployeeReaderSidebarItemText">
          {text}
        </div>
      </div>
    </div>
  )
}

function EmployeeReaderItems({ items = [] }) {
  return (
    <div className="EmployeeReaderSidebarItems">
      {items.map((_props) => <EmployeeReaderItem {..._props} />)}
    </div>
  )
}

function EmployeeReaderSidebar() {
  const location = useLocation();
  const { pathname } = location;
  const { courseId } = useParams();
  const [lessons, setLessons] = useState([]);
  const [items, setItems] = useState([]);
  
  useEffect(async () => {
    try {
      const res = await fetchLessons(courseId)
      setLessons(res);
    } catch (err) {
      // TODO: handle error
      console.log(err)
    }
  }, []);

  useEffect(() => {
    const arr = [];
    lessons.forEach(({
      id, // lessonId
      title,
      course_id,
    }) => {
      const path = `/courses/${course_id}/lessons/${id}`;
      arr.push({
        path: path,
        text: title,
        active: path === pathname,
      })
    })
    setItems(arr);
  }, [lessons, pathname]);
  
  return (
    <div className="EmployeeReaderSidebar">
      <div className="EmployeeReaderItemsContainer">
        <div className="EmployeeReaderItemsHeaderContainer">
          <div className="EmployeeReaderItemsHeaderTab" />
          <div className="EmployeeReaderItemsHeader">All Lessons</div>
        </div>
        <EmployeeReaderItems items={items} />
      </div>
    </div>
  )
}

export default EmployeeReaderSidebar;
